var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import React from "react";
import { Notification as RSNotification } from "rsuite";
var Notification = React.forwardRef(function (props, ref) {
    var children = props.children, closable = props.closable, type = props.type, header = props.header, onClose = props.onClose, rest = __rest(props, ["children", "closable", "type", "header", "onClose"]);
    return (_jsx("div", __assign({ ref: ref, style: { marginBottom: "4px" } }, { children: _jsx(RSNotification, __assign({ closable: closable, type: type, header: header, onClose: onClose }, rest, { children: children })) })));
});
export default Notification;
